import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit} from '@angular/core';
import {GridContainerClass} from './container.class';

@Component({
    selector: 'g-col',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<ng-content></ng-content>`,
    styleUrls: [`./col.component.scss`]
})

export class ColComponent extends GridContainerClass implements OnInit {
    @Input() span: number;
    /**
     * "Растущая" колонка будет заполнять все осташееся доступное место
     * @type {boolean}
     */
    @HostBinding('class._grow') @Input() grow = false;
    @HostBinding('class._shrink') @Input() shrink = true;

    /**
     * При необходимости будем переопределять то, что в стилях
     * @type {null}
     * @private
     */
    @HostBinding('style.boxSizing') private _boxSizing = null;

    ngOnInit() {
        super.ngOnInit();
        if (this.width === undefined) {
            /**
             * Если не задана ширина, что высчитываем ее на основании того, сколько колонок занимает текущая
             */

            if (!this.span) {
                // Нет ни ширины ни сколько колонок? Оставляем автоматически как есть
                return;
            }

            /**
             * Если мы делим сетку колонками, то включаем border-box для корректного отображения
             * @type {string}
             * @private
             */
            this._boxSizing = 'border-box';

            if (this.span <= 0 || this.span > 12) {
                this.span = 12;
            }

            this.width = ((this.span / 12 ) * 100) + '%';
        } else {
            /**
             * Если ширина задана числом, значит это пиксели
             */
            if (typeof this.width === 'number') {
                this.width = this.width + 'px';
            }
        }
    }
}
